//---------------------------------------------------------------------
// React, MUI, and other third-party modules imports
//---------------------------------------------------------------------
import React, { useEffect, useContext } from 'react';
// import { useState, useEffect, useContext, useCallback } from 'react';
import { makeStyles, Grid, Container, Typography } from '@material-ui/core';
import { useHistory } from 'react-router-dom';

//logo and images
import tickSrc from '../../images/advertise/bannerTicks.png';

//---------------------------------------------------------------------
// Common helpers and constants imports
//---------------------------------------------------------------------
import { AFITD_COMPANY_NAME, PATH_ADVERTISE, PATH_HOME } from '../../system/constants';
// import { unsubscribeRealtimeUpdates } from '../system/firebase';
import { LayoutContext } from '../../common/contexts';
import { setClassNameInDefns } from '../../common/definitionHelper';
// import AfitdTypography from '../../common/elemental/AfitdTypography';
// import AfitdTextField from '../../common/elemental/AfitdTextField';

//---------------------------------------------------------------------
// Page specific helpers and constants imports
//---------------------------------------------------------------------
import { HOMEPAGE_CONTACT, BASE_URL, PRICE_ADVERTISEMENT_PLACEMENT } from '../../common/constants';

//---------------------------------------------------------------------
// Common components imports
//---------------------------------------------------------------------
// import AfitdTypography from '../../common/elemental/AfitdTypography';
import Button from '../../common/elemental/AfitdButton';

//---------------------------------------------------------------------
// Page specific components imports
//---------------------------------------------------------------------
// import SubComponent1Example from './SubComponent1Example';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';

//---------------------------------------------------------------------
// Utilities (clsx, lodash, date-fns, etc.) imports
//---------------------------------------------------------------------
// import cx from 'clsx';
// import _get from 'lodash/get';

//---------------------------------------------------------------------
// CSS
//---------------------------------------------------------------------
const useStyles = makeStyles(theme => ({
    exampleWithNoPropsOnlyStyles: { color: 'red', marginTop: 30, marginBottom: 40 },
    nonReactElementExample: { color: 'blue', marginTop: 50, cursor: 'pointer' },
    heading: {
        textAlign: 'center',
        fontSize: '42px',
        fontWeight: 'bold',
        marginTop: '30px',
        [theme.breakpoints.down('md')]: { fontSize: 34 },
        [theme.breakpoints.down('sm')]: { fontSize: 24 },
    },
    bannerBody: {
        backgroundColor: '#111E14',
        // width: '377px',
        maxWidth: '500px',
        minHeight: '550px',
        borderRadius: '8px',
        // marginTop: '50px',
        [theme.breakpoints.down('md')]: { width: 300 },
        [theme.breakpoints.down('sm')]: { minHeight: '650px' },
    },
    bannerTitle: {
        paddingTop: '40px',
        textAlign: 'center',
        color: 'white',
        fontSize: '16px',
    },
    price: {
        fontSize: '65px',
        fontWeight: 'bold',
        color: 'white',
        marginTop: '10px',
        textAlign: 'center',
        [theme.breakpoints.down('md')]: { fontSize: 55 },
        [theme.breakpoints.down('sm')]: { fontSize: 70 },
    },
    tickBody: {
        textAlign: 'center',
        marginTop: '40px',
    },
    bannerDetails: {
        fontSize: '14px',
        lineHeight: '22px',
        color: '#9B9E9C',
        marginTop: '20px',
        paddingTop: '20px',
        paddingLeft: '50px',
        paddingRight: '50px',
        textAlign: 'center',
        [theme.breakpoints.down('sm')]: { paddingLeft: '30px', paddingRight: '30px' },
    },
    stepperBody: {
        background: 'none',
    },
    step: {
        padding: '0px 10px',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        marginBottom: '22px',
    },
    stepper: {
        position: 'relative',
    },
    stepCircle: {
        border: '5px solid #F0F2F6',
        borderRadius: '100%',
        width: '48px' /* +6 for border */,
        height: '35px',
        display: 'inline-block',
        // paddingTop: '10px',
        textAlign: 'center',
        fontSize: '18px',
        fontWeight: 'bold',
    },
    stepLine: {
        top: '36px',
        left: '23px',
        /*   height: 120px, */
        height: '90%',
        position: 'absolute',
        borderLeft: '5px solid #F0F2F6',
    },
    content: {
        marginLeft: '24px',
    },
    stepHeading: {
        fontSize: '20px',
        fontWeight: 'bold',
    },

    stepDetail: {
        fontSize: '16px',
        fontWeight: 'normal',
        lineHeight: '26px',
        marginTop: '5px',
    },
    bottomText: {
        fontSize: '20px',
        textAlign: 'center',
        [theme.breakpoints.down('sm')]: { fontSize: '18px' },
    },
    contactLink: {
        fontWeight: 'bold',
        textDecoration: 'underline',
        color: '#1D8A8B',
        cursor: 'pointer',
    },
    bannerBottomHeading: {
        margin: 'auto',
        fontWeight: 'bold',
        fontSize: '42px',
        lineHeight: '59px',
        marginTop: '80px',
        marginBottom: '74px',
        textAlign: 'center',
        [theme.breakpoints.down('sm')]: { fontSize: '28px', marginTop: 0, marginBottom: 25 },
    },
    haveQuestion: {
        marginTop: '100px',
        margin: 'auto',
        [theme.breakpoints.down('sm')]: { marginTop: '45px' },
    },
    contentBody: { padding: '70px', [theme.breakpoints.down('lg')]: { padding: '70px 30px' }, [theme.breakpoints.down('md')]: { padding: '70px 0px' } },
    beginButton: {
        height: '64px',
        width: '250px',
        fontSize: '30px',
        marginTop: '40px',
        [theme.breakpoints.down('md')]: { width: '230px' },
        [theme.breakpoints.down('sm')]: { width: '250px' },
    },
    bannerGrid: {
        [theme.breakpoints.down('sm')]: { display: 'flex', justifyContent: 'center', marginBottom: 40 },
    },
    benefitsOption: {
        paddingLeft: '30px',
        paddingRight: '30px',
        margin: 'auto',
        maxWidth: '350px',
    },
    simpleDescriptionDiv: {
        color: 'white',
        marginTop: '20px',
        display: 'flex',
        alignItems: 'center',
        // justifyContent: 'space-around',
    },
    checkIcon: {
        backgroundColor: 'white',
        color: '#1D8A8B',
        borderRadius: '100%',
    },
    adItem: {
        display: 'flex',
        alignItems: 'center',
    },
    adText: {
        color: 'white',
        paddingLeft: '5px',
    },
}));

//---------------------------------------------------------------------
// Get definitions
//---------------------------------------------------------------------
const getDefns = params => {
    const { classes, history } = params;

    const defns = {
        helloText: { variant: 'h4' },
        textFieldExample: { value: 'Hello TextField' },
        nonReactElementExample: {
            onClick: evt => {
                alert('Clicked!');
            },
        },
        contentBody: { container: true, spacing: 1, justifyContent: 'center' },
        bannerGrid: { item: true, lg: 5, md: 5, sm: 12, xs: 12 },
        itemGrid: { item: true, lg: 7, md: 7, sm: 12, xs: 12 },
        tickImg: {
            src: tickSrc,
            alt: '',
        },
        beginButton: {
            color: 'primary',
            onClick: () => history.push(`${BASE_URL}${PATH_ADVERTISE}/step1`),
        },
        stepperBody: {
            orientation: 'vertical',
        },
        contactLink: {
            onClick: () => history.push(`${BASE_URL}${PATH_HOME}/${HOMEPAGE_CONTACT}`),
        },
    };

    // Automatically inject className for matching keys
    setClassNameInDefns(defns, classes);

    return defns;
};

//---------------------------------------------------------------------
// Helper functions
//---------------------------------------------------------------------

//---------------------------------------------------------------------
// Component
//---------------------------------------------------------------------
const StartPage = props => {
    //---------------------------------------------------------------------
    // From context and other hooks
    //---------------------------------------------------------------------
    const classes = useStyles();
    const history = useHistory();

    // const appContext = useContext(AppContext);
    // const { currentUser, userId, profileData, currentEmployer, employerId, lovs } = appContext;

    const layoutContext = useContext(LayoutContext);
    const { scrollToPageTop } = layoutContext;
    // const { setSnackbarMessage, setSnackbarErrorMessage } = layoutContext;

    //---------------------------------------------------------------------
    // From props
    //---------------------------------------------------------------------
    // const { propExample } = props;

    //---------------------------------------------------------------------
    // Local states
    //---------------------------------------------------------------------
    // const [isDirty, setIsDirty] = useState(false);

    //---------------------------------------------------------------------
    // Side effects
    //---------------------------------------------------------------------
    // on mount, scroll to the top of the page
    useEffect(() => {
        scrollToPageTop();
    }, [scrollToPageTop]);

    //---------------------------------------------------------------------
    // Derived
    //---------------------------------------------------------------------
    const stepsData = [
        {
            heading: 'Tell Us About You',
            detail: 'We’re looking for the usual information like your company/ organization’s name, point of contact, email address, etc.',
        },
        {
            heading: 'Upload Your Advertisement Graphic',
            detail: `Upload the graphic for your advertisement.Accepted file formats:  PNG, JPEG. <i><b>*Appropriate Content ONLY*</b> - ${AFITD_COMPANY_NAME} has the right to reject ANY advertisement request that does not meet our terms and conditions.</i>`,
        },
        {
            heading: 'Select Pages For Advertisement',
            detail: 'Choose the search page where your advertisement will run. There are three search pages to choose from. You can place one advertisement per page in a single transaction (three total).',
        },
        {
            heading: 'Select Date & Time Slots',
            detail: `Choose the date and time slot that the advertisement will run. Click the ‘Check Availability’ button to see if your selected placement is available for purchase. `,
        },
        {
            heading: 'Submit Request ',
            detail: `Review your submission request to ensure accuracy. Once satisfied, click the ‘Proceed to Payment’ button. `,
        },
        {
            heading: 'Process Payment',
            detail: `We accept all major credit cards for your convenience. Enter your payment information and click the ‘Purchase’ button to complete the order. Congratulations, you did it! Your advertisement will display on the selected search page on the day and time chosen.`,
        },
    ];

    //---------------------------------------------------------------------
    // useCallback / Event handlers
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Definitions
    //---------------------------------------------------------------------
    const defns = getDefns({ classes, props, history });

    //---------------------------------------------------------------------
    // Render
    //---------------------------------------------------------------------
    return (
        <Container maxWidth="xl">
            <div {...defns.root}>
                <br />
                <br />
                <div {...defns.heading}>ADVERTISING SUBMISSION PROCESS</div>
                <Grid {...defns.contentBody}>
                    <Grid {...defns.bannerGrid}>
                        <div {...defns.bannerBody}>
                            <div {...defns.bannerTitle}>FLAT RATE PRICING</div>
                            <div {...defns.price}>${PRICE_ADVERTISEMENT_PLACEMENT} USD </div>
                            <div {...defns.tickBody}>
                                <div {...defns.benefitsOption}>
                                    <div {...defns.adItem}>
                                        <CheckCircleIcon {...defns.checkIcon} />{' '}
                                        <Typography variant="subtitle1" {...defns.adText}>
                                            1 Placement
                                        </Typography>
                                    </div>
                                    <div {...defns.simpleDescriptionDiv}>
                                        <div {...defns.adItem}>
                                            <CheckCircleIcon {...defns.checkIcon} />{' '}
                                            <Typography variant="subtitle1" {...defns.adText}>
                                                1 Page
                                            </Typography>
                                            &nbsp;&nbsp;&nbsp;&nbsp;
                                        </div>
                                        <div {...defns.adItem}>
                                            <CheckCircleIcon {...defns.checkIcon} />{' '}
                                            <Typography variant="subtitle1" {...defns.adText}>
                                                30 Minutes
                                            </Typography>
                                        </div>
                                    </div>
                                </div>
                                <Button {...defns.beginButton}>
                                    <b>Begin AD Process</b>
                                </Button>
                            </div>
                            <div {...defns.bannerDetails}>
                                * Multiple hours, pages, and regions can be purchased <br />
                                at ${PRICE_ADVERTISEMENT_PLACEMENT} USD per additional placement.
                            </div>
                        </div>
                    </Grid>
                    <Grid {...defns.itemGrid}>
                        <div style={{ maxWidth: '600px' }}>
                            {stepsData?.map((item, index) => (
                                <div {...defns.step}>
                                    <div {...defns.stepper}>
                                        <div {...defns.stepCircle}>{index + 1}</div>
                                        {index === 5 ? <></> : <div {...defns.stepLine}></div>}
                                    </div>

                                    <div {...defns.content}>
                                        <div {...defns.stepHeading}>{item?.heading}</div>
                                        <div {...defns.stepDetail}>
                                            {index === 1 ? (
                                                <>
                                                    Upload the graphic for your advertisement.
                                                    <br />
                                                    Accepted file formats: PNG, JPEG. <br />
                                                    <i>
                                                        <b>*Appropriate Content ONLY*</b> - {AFITD_COMPANY_NAME} has the right to reject ANY advertisement request that does not
                                                        meet our terms and conditions.
                                                    </i>
                                                </>
                                            ) : (
                                                item?.detail
                                            )}
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </Grid>
                </Grid>
                <div {...defns.haveQuestion}>
                    <div {...defns.bannerBottomHeading}>Have other questions?</div>
                    <div {...defns.bottomText}>
                        <span {...defns.contactLink}>Contact Us</span>
                        <span> here so we can help</span>
                    </div>
                </div>
            </div>
        </Container>
    );
};

export default StartPage;
